import PropTypes from 'prop-types';
import React from "react";
import {connect} from "react-redux";

import dropHandler from "./common/DropHandler";
import TouchHandler from "./common/TouchHandler";

import ViewManager from "./components/ViewManager.jsx";
import HelpModal from "./components/HelpModal.jsx";
import DropTarget from "./components/DropTarget.jsx";
import BulletNavigation from "./components/BulletNavigation.jsx";
import ToolTip from "components/ToolTip.jsx";
import TopBar from "./components/TopBar.jsx";

const DropOverlay = () => <div className="drop-overlay"></div>;

const AddChart = ({add}) => <div onClick={add} className="add-chart button">+</div>;
AddChart.propTypes = {
    add: PropTypes.func.isRequired
};


const NoCharts = () => (
    <div className="no-charts">
        No charts configured. <br/>
        Drag a file here <br/>
        or press N to get started.
    </div>
);

@connect(state =>({
    charts: state.charts,
    selected: state.viewer.selected,
    exposed: state.viewer.exposed
}), {})
class App extends React.Component {
    static propTypes = {
        actions: PropTypes.object,
        embedded: PropTypes.bool,
        touchControls: PropTypes.bool,
        exposed: PropTypes.bool,
        selected: PropTypes.number,
        charts: PropTypes.array
    };

    render() {
        let {actions, embedded, touchControls, exposed, selected, charts} = this.props;

        if (embedded) {
            return (
                <app>
                    <ViewManager {...this.props} exposed={false}/>
                </app>
            );
        }

        let addChart = () => {
            actions.addChart({});
            actions.selectChart(charts.length);
            actions.expose(false);
        };

        let tree = (
            <app>
                {exposed || charts.length == 0 ?
                    <TopBar text="AbuseSA KPI"><AddChart add={addChart}/></TopBar>:
                    null
                }
                <ViewManager {...this.props}/>
                {!exposed && charts.length > 1 ?
                    <BulletNavigation count={charts.length} selected={selected} onSelect={actions.selectChart}/>:
                    null
                }
                {charts.length == 0 ? <NoCharts/> : null}
                <HelpModal />
                <DropOverlay />
                <ToolTip />
            </app>
        );

        if (touchControls) {
            tree = (
                <TouchHandler
                    selected={selected}
                    select={actions.selectChart}
                    expose={actions.expose}
                >
                    {tree}
                </TouchHandler>
            );
        }

        return (
            <DropTarget onDrop={dropHandler(actions)} dropTarget={document.body}>
                {tree}
            </DropTarget>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/kpi/app.js